import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row, Alert, Spinner } from "react-bootstrap";
import bg2 from "../assets/img/image.jpg";
import logo from "../assets/img/IMG-20250130-WA0008.jpg";
import { API_BASE_URL } from "../constants/api";
import { COLORS } from "../constants/colors";

export default function Signin2() {
  const navigate = useNavigate();
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  
  const [step, setStep] = useState('login');
  const [userId, setUserId] = useState(null);
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [rememberDevice, setRememberDevice] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Veuillez remplir tous les champs");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${API_BASE_URL}/login.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (!response.ok) {
        setError(data.message || "Email ou mot de passe incorrect");
        setLoading(false);
        return;
      }
      if (data.success) {
        if (data.requires_2fa) {
          setUserId(data.user_id);
          setStep('verify');
          setLoading(false);
        } else {
          localStorage.setItem("token", data.token);
          localStorage.setItem("user", JSON.stringify(data.user));
          navigate("/dashboard/finance");
        }
      } else {
        setError(data.message || "Email ou mot de passe incorrect");
      }
    } catch (err) {
      console.error("Erreur de connexion:", err);
      setError(`Erreur de connexion au serveur: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify2FA = async (e) => {
    e.preventDefault();
    if (!twoFactorCode || twoFactorCode.length !== 6) {
      setError("Veuillez saisir le code à 6 chiffres");
      return;
    }
    setVerifying(true);
    setError("");
    try {
      const response = await fetch(`${API_BASE_URL}/verify_2fa.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ 
          user_id: userId, 
          code: twoFactorCode,
          remember: rememberDevice 
        }),
      });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        navigate("/dashboard/finance");
      } else {
        setError(data.message || "Code incorrect");
        setTwoFactorCode("");
      }
    } catch (err) {
      console.error("Erreur vérification 2FA:", err);
      setError(`Erreur de vérification: ${err.message}`);
    } finally {
      setVerifying(false);
    }
  };

  const handleResendCode = async () => {
    setVerifying(true);
    setError("");
    try {
      const response = await fetch(`${API_BASE_URL}/resend_2fa.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ user_id: userId }),
      });
      const data = await response.json();
      if (data.success) {
        setError("");
        alert("Un nouveau code vous a été envoyé");
      } else {
        setError(data.message || "Erreur lors de l'envoi du code");
      }
    } catch (err) {
      console.error("Erreur renvoi code:", err);
      setError(`Erreur de connexion: ${err.message}`);
    } finally {
      setVerifying(false);
    }
  };

  const handleBackToLogin = () => {
    setStep('login');
    setTwoFactorCode("");
    setError("");
  };

  return (
    <>
      <style>{`
        .page-sign-split {
          min-height: 100vh;
          display: flex;
          align-items: stretch;
          background: #ffffff;
        }

        /* ===== PARTIE GAUCHE AVEC IMAGE DE FOND ===== */
        .split-left {
          flex: 1;
          position: relative;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 3rem;
          color: white;
        }

        .split-left .bg-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 0;
        }

        .split-left .overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, ${COLORS.primary}90 0%, ${COLORS.primaryDark}85 100%);
          z-index: 1;
        }

        .split-left .brand {
          position: relative;
          z-index: 2;
          text-align: center;
          max-width: 400px;
        }

        .split-left .brand .icon {
          font-size: 4rem;
          margin-bottom: 1rem;
          display: block;
          text-shadow: 0 4px 20px rgba(0,0,0,0.2);
          color: white;
        }

        .split-left .brand h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 0.5rem;
          text-shadow: 0 2px 20px rgba(0,0,0,0.15);
        }

        .split-left .brand p {
          opacity: 0.9;
          max-width: 300px;
          margin: 0 auto;
          line-height: 1.6;
          text-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        .split-left .brand .stats {
          display: flex;
          gap: 2rem;
          margin-top: 2rem;
          justify-content: center;
        }

        .split-left .brand .stats div {
          text-align: center;
        }

        .split-left .brand .stats .number {
          font-size: 1.8rem;
          font-weight: 700;
          text-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        .split-left .brand .stats .label {
          font-size: 0.8rem;
          opacity: 0.8;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* ===== PARTIE DROITE ===== */
        .split-right {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          background: white;
        }

        .login-card-split {
          max-width: 420px;
          width: 100%;
        }

        /* ===== LOGO SIMPLE ET NET ===== */
        .logo-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 2rem;
          text-align: center;
        }

        .logo-wrap img {
          height: 80px;
          transition: transform 0.3s ease;
          display: block;
        }

        .logo-wrap img:hover {
          transform: scale(1.05);
        }

        .logo-wrap .brand-name {
          font-weight: 700;
          font-size: 1.4rem;
          color: ${COLORS.primaryDark};
          letter-spacing: -0.3px;
          margin-top: 0.6rem;
        }

        .logo-wrap .brand-name .highlight {
          color: ${COLORS.secondary};
        }

        .login-card-split h2 {
          font-size: 1.6rem;
          font-weight: 700;
          color: ${COLORS.primaryDark};
          margin-bottom: 0.3rem;
        }

        .login-card-split .sub {
          color: #94a3b8;
          margin-bottom: 2rem;
        }

        /* ===== FORMULAIRES ===== */
        .form-label-split {
          font-weight: 600;
          color: ${COLORS.primaryDark};
          font-size: 0.85rem;
          margin-bottom: 0.3rem;
        }

        .form-control-split {
          border: 1.5px solid #e2e8f0;
          border-radius: 12px !important;
          padding: 0.7rem 1rem;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          background: white;
        }

        .form-control-split:focus {
          border-color: ${COLORS.primary};
          box-shadow: 0 0 0 3px ${COLORS.primary}15;
        }

        .input-icon-wrapper {
          position: relative;
        }

        .input-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 1.1rem;
          z-index: 2;
        }

        .input-with-icon {
          padding-left: 2.75rem !important;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px !important;
          padding: 0.7rem 1rem;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          background: white;
        }

        .input-with-icon:focus {
          border-color: ${COLORS.primary};
          box-shadow: 0 0 0 3px ${COLORS.primary}15;
        }

        .password-wrap {
          position: relative;
        }

        .password-input-split {
          padding-left: 2.75rem !important;
          padding-right: 44px !important;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px !important;
          padding: 0.7rem 1rem;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          background: white;
        }

        .password-input-split:focus {
          border-color: ${COLORS.primary};
          box-shadow: 0 0 0 3px ${COLORS.primary}15;
        }

        .password-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 1.1rem;
          z-index: 2;
        }

        .password-toggle-split {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          background: transparent;
          border: none;
          color: #94a3b8;
          cursor: pointer;
          transition: color 0.3s ease;
          z-index: 5;
        }

        .password-toggle-split:hover {
          color: ${COLORS.primary};
        }

        .forgot-split {
          text-align: right;
          margin-top: 0.3rem;
        }

        .forgot-split a {
          font-size: 0.8rem;
          color: ${COLORS.primary};
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .forgot-split a:hover {
          color: ${COLORS.primaryDark};
          text-decoration: underline;
        }

        .btn-split {
          background: linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryDark});
          border: none;
          border-radius: 12px !important;
          padding: 0.8rem;
          font-weight: 600;
          font-size: 1rem;
          color: white;
          transition: all 0.3s ease;
          width: 100%;
          box-shadow: 0 4px 16px rgba(41,90,167,0.2);
        }

        .btn-split:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(41,90,167,0.3);
        }

        .btn-split:disabled {
          opacity: 0.6;
        }

        .footer-split {
          text-align: center;
          margin-top: 1.5rem;
          font-size: 0.9rem;
          color: #94a3b8;
        }

        .footer-split a {
          color: ${COLORS.primary};
          font-weight: 600;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .footer-split a:hover {
          color: ${COLORS.primaryDark};
          text-decoration: underline;
        }

        /* ===== 2FA ===== */
        .two-factor-step {
          animation: fadeInUp 0.5s ease-out;
        }

        .twofa-icon-wrapper {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: ${COLORS.primary}20;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
        }

        .twofa-icon-wrapper i {
          font-size: 40px;
          color: ${COLORS.primary};
        }

        .code-input {
          letter-spacing: 6px;
          font-size: 1.8rem;
          font-weight: 700;
          text-align: center;
          padding: 12px;
          border-radius: 12px !important;
          border: 1.5px solid #e2e8f0;
          font-family: monospace;
        }

        .code-input:focus {
          border-color: ${COLORS.primary};
          box-shadow: 0 0 0 3px ${COLORS.primary}15;
        }

        .custom-checkbox .form-check-input {
          width: 1.1rem;
          height: 1.1rem;
          margin-top: 0.15rem;
          border: 1.5px solid #cbd5e1;
          border-radius: 4px;
          cursor: pointer;
        }

        .custom-checkbox .form-check-input:checked {
          background-color: ${COLORS.primary};
          border-color: ${COLORS.primary};
        }

        .custom-checkbox .form-check-label {
          color: #64748b;
          font-size: 0.85rem;
          cursor: pointer;
        }

        .back-link {
          color: ${COLORS.primary};
          font-weight: 500;
          text-decoration: none;
          font-size: 0.85rem;
          transition: color 0.3s ease;
        }

        .back-link:hover {
          color: ${COLORS.primaryDark};
          text-decoration: underline;
        }

        .resend-link {
          color: ${COLORS.secondary};
          font-weight: 500;
          text-decoration: none;
          font-size: 0.85rem;
          transition: color 0.3s ease;
        }

        .resend-link:hover {
          color: ${COLORS.secondaryDark};
          text-decoration: underline;
        }

        .alert-modern {
          border-radius: 12px;
          border: 1px solid rgba(239,68,68,0.15);
          background: rgba(239,68,68,0.04);
          padding: 0.8rem 1rem;
          font-size: 0.9rem;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 992px) {
          .page-sign-split {
            flex-direction: column;
          }
          .split-left {
            padding: 2.5rem;
            min-height: 280px;
          }
          .split-left .brand h1 {
            font-size: 2rem;
          }
          .split-left .brand .stats {
            gap: 1.5rem;
          }
          .split-left .brand .stats .number {
            font-size: 1.4rem;
          }
          .split-left .brand .icon {
            font-size: 3rem;
          }
        }

        @media (max-width: 768px) {
          .split-left {
            min-height: 220px;
            padding: 2rem;
          }
          .split-left .brand p {
            display: none;
          }
          .split-left .brand .stats {
            gap: 1rem;
          }
          .split-left .brand .stats .number {
            font-size: 1.2rem;
          }
          .split-left .brand .stats .label {
            font-size: 0.7rem;
          }
        }

        @media (max-width: 576px) {
          .split-left {
            min-height: 180px;
            padding: 1.5rem;
          }
          .split-left .brand .icon {
            font-size: 2.2rem;
            margin-bottom: 0.5rem;
          }
          .split-left .brand h1 {
            font-size: 1.4rem;
          }
          .split-left .brand .stats {
            gap: 0.8rem;
            margin-top: 1rem;
          }
          .split-left .brand .stats .number {
            font-size: 1rem;
          }
          .split-left .brand .stats .label {
            font-size: 0.6rem;
          }
          .split-right {
            padding: 1rem;
          }
          .login-card-split {
            padding: 0.5rem;
          }
          .logo-wrap img {
            width: 60px;
            height: 60px;
          }
          .logo-wrap .brand-name {
            font-size: 1.1rem;
          }
          .login-card-split h2 {
            font-size: 1.3rem;
          }
          .code-input {
            letter-spacing: 4px;
            font-size: 1.4rem;
          }
        }
      `}</style>

      <div className="page-sign-split">
        {/* ===== PARTIE GAUCHE ===== */}
        <div className="split-left">
          <img src={bg2} alt="Background" className="bg-image" />
          <div className="overlay"></div>
          <div className="brand">
            {/* Icône Remix pour la gestion des RH */}
            <span className="icon">
              <i className="ri-team-line"></i>
            </span>
            <h1>Gestion des RH</h1>
            <p>La solution complète pour gérer vos employés, contrats et ressources humaines</p>
            <div className="stats">
              <div>
                <div className="number">500+</div>
                <div className="label">Employés</div>
              </div>
              <div>
                <div className="number">1.2K+</div>
                <div className="label">Contrats</div>
              </div>
              <div>
                <div className="number">4.9★</div>
                <div className="label">Satisfaction</div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== PARTIE DROITE ===== */}
        <div className="split-right">
          <div className="login-card-split">
            <div className="logo-wrap">
              <img src={logo} alt="Logo" />
              <span className="brand-name">
                HR<span className="highlight">Manager</span>
              </span>
            </div>

            {error && (
              <Alert variant="danger" onClose={() => setError("")} dismissible className="alert-modern mb-3">
                <div className="d-flex align-items-center">
                  <i className="ri-error-warning-line me-2" style={{ color: COLORS.danger }}></i>
                  <span>{error}</span>
                </div>
              </Alert>
            )}

            {step === 'login' ? (
              <>
                <h2>Connexion</h2>
                <p className="sub">Connectez-vous pour accéder à votre espace RH</p>

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-split">Email</Form.Label>
                    <div className="input-icon-wrapper">
                      <i className="ri-mail-line input-icon"></i>
                      <Form.Control
                        type="email"
                        placeholder="exemple@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading}
                        required
                        className="input-with-icon"
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-split">Mot de passe</Form.Label>
                    <div className="password-wrap">
                      <i className="ri-lock-line password-icon"></i>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Entrez votre mot de passe"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={loading}
                        required
                        className="password-input-split"
                      />
                      <button
                        type="button"
                        className="password-toggle-split"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i className={showPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                      </button>
                    </div>
                    <div className="forgot-split">
                      <Link to="/forgot-password">Mot de passe oublié ?</Link>
                    </div>
                  </Form.Group>

                  <Button type="submit" className="btn-split" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner size="sm" className="me-2 text-white" />
                        Connexion en cours...
                      </>
                    ) : (
                      "Se connecter"
                    )}
                  </Button>
                </Form>

                <div className="footer-split">
                  Vous n'avez pas de compte ? <Link to="/register">S'inscrire</Link>
                </div>
              </>
            ) : (
              <div className="two-factor-step">
                <div className="twofa-icon-wrapper">
                  <i className="ri-shield-keyhole-line"></i>
                </div>
                <h2 className="text-center">Vérification 2FA</h2>
                <p className="sub text-center">
                  Saisissez le code à 6 chiffres envoyé à votre application d'authentification
                </p>

                <Form onSubmit={handleVerify2FA}>
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label-split">Code de vérification</Form.Label>
                    <Form.Control
                      type="text"
                      value={twoFactorCode}
                      onChange={(e) => setTwoFactorCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                      placeholder="000000"
                      required
                      size="lg"
                      className="code-input"
                      maxLength="6"
                      disabled={verifying}
                    />
                    <Form.Text className="text-muted small">
                      Entrez les 6 chiffres affichés dans votre application
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Check
                      type="checkbox"
                      id="remember-device"
                      label="Mémoriser cet appareil pendant 30 jours"
                      checked={rememberDevice}
                      onChange={(e) => setRememberDevice(e.target.checked)}
                      disabled={verifying}
                      className="custom-checkbox"
                    />
                  </Form.Group>

                  <Button
                    type="submit"
                    className="btn-split"
                    disabled={verifying || twoFactorCode.length !== 6}
                  >
                    {verifying ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Vérification...
                      </>
                    ) : (
                      "Vérifier"
                    )}
                  </Button>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      type="button"
                      className="resend-link"
                      onClick={handleResendCode}
                      disabled={verifying}
                    >
                      <i className="ri-mail-send-line me-1"></i>
                      Renvoyer le code
                    </button>

                    <button
                      type="button"
                      className="back-link"
                      onClick={handleBackToLogin}
                      disabled={verifying}
                    >
                      <i className="ri-arrow-left-line me-1"></i>
                      Retour
                    </button>
                  </div>
                </Form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}